export const apiBaseUrl = 'https://apiyourflight.x1jets.com'
export const imageBaseUrl = 'https://apiops.x1jets.com'
